import { render, staticRenderFns } from "./CompanyDecks.vue?vue&type=template&id=4117923c&scoped=true"
import script from "./CompanyDecks.vue?vue&type=script&lang=ts"
export * from "./CompanyDecks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4117923c",
  null
  
)

export default component.exports